import {
  setConductricsSelectionOK,
  Status,
  useConductricsSelection,
} from '@dx-ui/framework-conductrics';
import { logWarning } from '@dx-ui/framework-logger';

export function useAutoLoginTest() {
  const AGENT_ID = 'a-auth-719';
  const { isLoaded } = useConductricsSelection(AGENT_ID, Status.PENDING);
  const startAutoLoginTest = async () => {
    const res = await setConductricsSelectionOK(AGENT_ID).catch((error) =>
      logWarning('Unable to set OK on conductrics selection', error, AGENT_ID)
    );
    return isLoaded && res?.sels?.[AGENT_ID] === 'B';
  };
  return { startAutoLoginTest, isAutoLoginTestLoaded: isLoaded };
}
